import { compose, withPropsOnChange } from "recompose"
import { getEquipment } from "../api/entities/equipment"
import apiTransport from "../api/apiTransport"

const withEqupment = compose(
  withPropsOnChange(
    [`issue`],
    ({ issue: { customFields: { object_code: objectCode } = {} } = {} }) => ({
      payload: objectCode,
      load: getEquipment,
      propName: `equipment`,
    }),
  ),
  apiTransport,
)

export default withEqupment
